module.exports = __webpack_public_path__ + "static/agency-banner-frontline-e93c34d4a8764f652488790b9d205fcf.png";